import { CHANNEL_DISPLAY_NAMES } from './constants';

export const extractSlackDetails = (path: string) => {
  const channelMatch = path.match(/channels\/([^/]+)/);
  const channelId = channelMatch ? channelMatch[1] : 'unknown';
  
  const fileNameMatch = path.match(/\/([^/]+)$/);
  let fileName = fileNameMatch ? fileNameMatch[1] : 'unknown';
  
  // Clean up the filename
  fileName = decodeURIComponent(fileName)
    .replace(/_thumb\.png$/, '')
    .replace(/^F[A-Z0-9]+_/, '');
  
  // Extract date from path (format: YYYYMMDD)
  const dateMatch = path.match(/slack_mattermost_export\/(\d{8})/);
  let postDate = 'Unknown';
  
  if (dateMatch && dateMatch[1]) {
    const year = dateMatch[1].substring(0, 4);
    const month = dateMatch[1].substring(4, 6);
    const day = dateMatch[1].substring(6, 8);
    postDate = `${month}/${day}/${year}`;
  }
    
  return {
    channelId,
    channelName: CHANNEL_DISPLAY_NAMES[channelId] || channelId,
    fileName,
    postDate
  };
};

export const extractMiscIntelDetails = (path: string, imagePath: string) => {
  const fileNameMatch = path.match(/\/([^/]+)$/);
  let fileName = fileNameMatch ? fileNameMatch[1] : 'unknown';
  
  // Clean up the filename
  fileName = decodeURIComponent(fileName)
    .replace(/\.pdf$|\.jpg$|\.png$|\.jpeg$/i, '')
    .replace(/_/g, ' ');
  
  // Extract page number without adding 1
  const pageMatch = imagePath.match(/_page(\d+)_/);
  const pageNumber = pageMatch ? parseInt(pageMatch[1]) : 'Unknown';
    
  return {
    fileName,
    pageNumber
  };
};

export const formatModelName = (model: string) => {
  return model
    .split('_')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

export const getDocumentUrl = (source: string, rawPath: string, API_URL: string): string => {
  switch (source) {
    case 'slack_mattermost_export':
      return `${API_URL}/api/documents/${rawPath.split('slack_mattermost_export/')[1]}`;
    case 'satg_suspects':
      return `${API_URL}/api/documents/${rawPath.split('satg_suspects/')[1]}`;
    case 'misc_intel':
      return `${API_URL}/api/misc_documents/${rawPath.split('misc_intel/')[1]}`;
    case 'oj_bookings':
      const filename = rawPath.split('/').pop();
      return `${API_URL}/api/images/oj_bookings/${filename}`;
    default:
      return `${API_URL}/api/images/${source}/${rawPath.split('/').pop()}`;
  }
};
